
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import AdvantageCard from "~/components/vacancies/AdvantageCard.vue";
export default BaseCmsBlock.extend({
  name: 'VacanciesCompanyAdvantagesBlock',

  components: {
    AdvantageCard,
  },

  computed: {
    localValues: function () {
      return this.externalData?.VacanciesLast5YearsBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
  },
});
